<template>
  <div class="side-wrapper">
    <div
      class="extend-bar"
      @mousedown.prevent="onExtendDown"
      @touchstart.prevent="onExtendDown"
    ></div>
    <div
      class="side task-info"
      :style="panelStyle"
      ref="side-panel"
    >
      <div class="page-header" v-if="!task">

        <div class="flexrow header-title">
          <button-simple
            class="flexrow-item close-button"
            icon="right"
            @click="onCloseClick"
          />
          <div class="title flexrow-item">
            <p>
              {{ $t('tasks.no_task_selected') }}
            </p>
          </div>
        </div>
      </div>
      <div class="page-header" v-else-if="singleTaskSelected">
        <!-- <div class="preview-list flexrow">
          <span>{{ $t('entities.preview_files.revision') }}: </span>
          <span
            :class="{
              'flexrow-item': true,
              'rev-tab': true,
              selected: currentPreviewIndex === index
            }"
            :key="'preview-' + preview.id"
            @click="onPreviewChanged(index)"
            v-for="(preview, index) in lastFivePreviews"
          >
            {{ preview.revision }}
          </span>
          <span
            :class="{
              'flexrow-item': true,
              'rev-tab': true,
              selected: currentPreviewIndex === -1
            }"
            :key="'preview-nothing'"
            @click="onPreviewChanged(-1)"
            v-if="!isGlobal"
          >
            0
          </span>
        </div> -->
        <div
          class="flexrow header-title"
        >
          <button-simple
            class="flexrow-item close-button"
            icon="right"
            @click="onCloseClick"
          />
          <router-link
            v-if="isEntityBound && !isCurrentUserClient"
            class="flexrow-item title"
            :to="taskEntityPath"
          >
            {{ task ? title : 'Loading...' }}
          </router-link>
          <a v-else class="flexrow-item title">
            {{ task ? title : 'Loading...' }}
          </a>
          <span class="flexrow-item preview-label">
            {{ $t('entities.preview_files.revision') }}:
          </span>
          <combobox
            class="flexrow-item preview-selector"
            :options="previewOptions"
            :thin="true"
            v-model="currentPreviewIndex"
            @input="onPreviewChanged"
          />
          <task-type-name
            class="flexrow-item task-type"
            :task-type="currentTaskType"
            :production-id="isGlobal ? null : currentProduction.id"
            v-if="currentTaskType"
          />
        </div>
      </div>
      <div class="page-header" v-else>
        <div class="flexrow header-title">
          <button-simple
            class="flexrow-item close-button"
            icon="right"
            @click="onCloseClick"
          />
          <div class="title flexrow-item">
            <p>
              {{ nbSelectedTasks + ' Tasks selected' }}
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="!isCurrentUserClient"
        class="flexrow task-information"
      >
        <button-simple
          class="flexrow-item set-thumbnail-button"
          icon="image"
          :disabled="!isSetThumbnailAllowed"
          :title="$t('tasks.set_preview')"
          @click="setCurrentPreviewAsEntityThumbnail"
          v-if="currentPreviewIndex >= 0 && isEntityBound && isCurrentUserManager && isPreview && extension !== 'gif'"
        />
        <subscribe-button
          class="flexrow-item subscribe-button"
          :subscribed="isAssigned || isSubscribed"
          @click="toggleSubscribe"
          v-if="!isAssigned"
        />
        
        <button-simple
          class="flexrow-item upload-revision-button"
          icon="upload"
          :title="$t('tasks.publish_revision')"
          @click="onAddPreviewClicked(true)"
          v-if="isEntityBound && !isCurrentUserClient"
        />
        <span class="due-date flexrow-item" v-if="task">
          {{ prettyDueDate }}
        </span>
        <span class="original-name flexrow-item" v-if="currentPreview">
          {{ currentPreview.original_name || ''}}.{{ currentPreview.extension || '' }}
        </span>
      </div>

      <div class="task-columns" ref="task-columns" v-if="task">
        <div
          :class="{
            'task-column': true,
            'preview-column': true,
            'sticky-preview': taskPreviews && taskPreviews.length > 0
          }"
          v-if="currentPreviewIndex >= 0 && isPreview && singleTaskSelected"
        >
          <div class="preview-column-content">
            <div class="preview"
              v-if=isEntityBound
            >
              <div
                v-show="taskPreviews && taskPreviews.length > 0"
              >
                <preview-player
                  :entity-preview-files="taskEntityPreviews"
                  :extra-wide="isExtraWide"
                  :is-assigned="isAssigned"
                  :last-preview-files="lastFivePreviews"
                  :light="!isWide"
                  :previews="currentPreview ? currentPreview.previews : []"
                  :read-only="isPreviewPlayerReadOnly"
                  :task="task"
                  :task-type-map="taskTypeMap"
                  @annotation-changed="onAnnotationChanged"
                  @change-current-preview="changeCurrentPreview"
                  @add-extra-preview="onAddExtraPreview"
                  @remove-extra-preview="onRemoveExtraPreview"
                  @previews-order-change="onPreviewsOrderChange"
                  @comment-added="onCommentAdded"
                  @comment-mark-clicked="onCommentMarkClicked"
                  @time-updated="onTimeUpdated"
                  ref="preview-player"
                />
              </div>

              <div
                class="no-preview"
                v-if="!taskPreviews || taskPreviews.length === 0"
              >
                <em>{{ $t('tasks.no_preview') }}</em>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="!isCurrentUserClient"
          class="task-column action-column"
        >
          <action-select
            v-if="selectedTasks"
            :previewForms="previewForms"
            :fps="parseInt(currentFps)"
            :time="isPreview ? currentTime : currentTimeRaw"
            :revision="currentRevision"
            @generate-playlist="generatePlaylist"
            @change-status="changeStatus"
            @add-comment="addComment"
            @add-preview="onAddPreviewClicked"
            @remove-preview="onPreviewFormRemoved"
            @task-deleted="$emit('task-deleted')"
          />
        </div>

        <add-plain-comment
          ref="add-comment"
          style="margin-top: 2em;"
          :user="user"
          :team="currentTeam"
          :task="task"
          :task-status="taskStatusForCurrentUser"
          :light="true"
          :time="isPreview ? currentTime : currentTimeRaw"
          :is-loading="loading.addComment"
          :attached-file-name="attachedFileName"
          :is-error="errors.addComment"
          :previewForms="previewForms"
          :fps="parseInt(currentFps)"
          :revision="currentRevision"
          :hide-timecode="!singleTask || nbSelectedTasks > 1"
          @add-comment="addComment"
          @add-preview="onAddPreviewClicked"
          @file-drop="selectFile"
          v-if="isCommentingAllowed && !singleTaskSelected"
        />

        <div class="task-column tab-column" v-if="singleTaskSelected && !isCurrentUserClient">
          <button
            :key="tab + 'tasks-button'"
            :class="{
              'button': true,
              'tab-button': true,
              'left-button': true,
              'active-tab-button': tab === 'tasks',
            }"
            @click="onTabTasksClick"
          >
            {{ $t('tasks.history_tab') }}
          </button>
          <button
            :key="tab + 'comments-button'"
            :class="{
              'button': true,
              'tab-button': true,
              'right-button': true,
              'active-tab-button': tab === 'comments',
            }"
            @click="onTabCommentsClick"
          >
            {{ $t('tasks.comments_tab') }}
          </button>
          <hr>
        </div>

        <div
          :key="tab"
          v-if="tab === 'tasks' && singleTaskSelected && !isCurrentUserClient"
          class="task-column revisions-column bottom-column"
        >
          <task-history-list
            :key="task.id"
            :task="weirdTasksSelected"
          />
        </div>

        <div
          :key="tab"
          v-if="(tab === 'comments' || isCurrentUserClient) && singleTaskSelected"
          class="task-column comments-column bottom-column"
        >
          <add-plain-comment
            ref="add-comment"
            :user="user"
            :team="currentTeam"
            :task="task"
            :task-status="getTaskStatusForCurrentUser(task.project_id)"
            :light="true"
            :is-loading="loading.addComment"
            :attached-file-name="attachedFileName"
            :is-error="errors.addComment"
            :time="isPreview ? currentTime : currentTimeRaw"
            :previewForms="previewForms"
            :fps="parseInt(currentFps)"
            :revision="currentRevision"
            :hide-timecode="!singleTask || nbSelectedTasks > 1"
            @add-comment="addComment"
            @add-preview="onAddPreviewClicked"
            @file-drop="selectFile"
            v-if="isCommentingAllowed"
          />
          <div :class="{
            flexrow: true,
            mt1: true,
            widemt: isWide,
            vidmt: currentPreview?.extension === 'mp4',
            topmt: currentPreviewIndex === -1 || !isPreview || !taskPreviews || taskPreviews.length === 0,
          }">
            <div class="flexrow-item show-hidden button-group" v-if="!isCurrentUserClient">
              <label class="label"> {{  $t('main.sort_by') }} </label>
              <combobox
                class="flexrow-item selector"
                label=""
                :options="sortingOptions"
                :thin="true"
                v-model="sorting"
                @input="updateSorting"
              />
            </div>
            <div class="flexrow-item show-hidden button-group" v-if="!isCurrentUserClient">
              <label class="label"> {{  $t('comments.show_hidden') }} </label>
              <checkbox
                label=""
                :toggle=true
                v-model="isShowHidden"
              />
            </div>
            <div
              class="flexrow-item copy-paste button-group"
            >
              <label class="label"> {{  $t('comments.copy_selection') }} </label>
              <p class="btgrp">
                <button-simple
                  :class="{
                    'left-button': true,
                    'disabled': copyDisabled
                  }"
                  title="Copy"
                  icon="compare"
                  @click="onCopyClick"
                />
                <button-simple
                  :class="{
                    'right-button': true,
                    'disabled': pasteDisabled
                  }"
                  title="Paste"
                  icon="clipboard"
                  @click="onPasteClick"
                />
              </p>
            </div>
            <div
              class="flexrow-item copy-paste button-group"
            >
              <label class="label">Filter Author</label>
              <people-field
                class="people-field"
                :people="commentAuthors"
                v-model="personFilter"
              />
            </div>
          </div>
          <div>
            <div>
              <div
                class="comments"
                v-if="taskHasComments && !loading.task"
              >
                <comment
                  :key="'comment' + comment.id"
                  :id="'com-' + comment.id"
                  :comment="comment"
                  :task="task"
                  :light="true"
                  :add-preview="onAddPreviewClicked"
                  :is-first="index === 0"
                  :is-last="index === pinnedCount"
                  :editable="comment.person && user.id === comment.person.id"
                  :revision="currentRevision"
                  :time="isPreview ? currentTime : currentTimeRaw"
                  :fps="parseInt(currentFps)"
                  :frame="currentFrame"
                  :team="currentTeam"
                  @select="onCommentSelect(comment, $event)"
                  @ack-comment="onAckComment"
                  @duplicate-comment="onDuplicateComment"
                  @pin-comment="onPinComment"
                  @edit-comment="onEditComment"
                  @close-comment="onCloseComment"
                  @hide-comment="onHideComment"
                  @delete-comment="onDeleteComment"
                  @checklist-updated="saveComment"
                  @time-code-clicked="event => { timeCodeClicked(event, index) }"
                  v-for="(comment, index) in taskComments"
                  v-if="((!currentPreview && !comment.revision) || (currentPreview?.revision === comment.revision)) &&
                    (!personFilter || (personFilter && comment.person.id === personFilter.id)) && (
                      comment.text?.length > 0 ||
                      comment.checklist?.length > 0 ||
                      comment.attachment_files?.length > 0
                    ) && (isShowHidden || !comment.hidden)"
                />
              </div>
              <div class="no-comment" v-else-if="!loading.task">
                <em>
                  {{ $t('tasks.no_comment')}}
                </em>
              </div>
            </div>
          </div>

          <div class="has-text-centered" v-if="loading.task">
            <spinner />
          </div>
        </div>
      </div>

      <div class="task-columns" v-else>
        <button
          v-if="!isCurrentUserClient"
          class="create-button"
          title="Create Task"
          @click="onCreateClick"
        >
          Create Task
        </button>
      </div>

      <template v-if="task">
        <add-preview-modal
          ref="add-preview-modal"
          :active="modals.addPreview"
          :is-loading="loading.addPreview"
          :is-error="errors.addPreview"
          @cancel="closeAddPreviewModal"
          @confirm="confirmAddPreviewModal"
        />

        <add-preview-modal
          ref="add-extra-preview-modal"
          :active="modals.addExtraPreview"
          :is-loading="loading.addExtraPreview"
          :is-error="errors.addExtraPreview"
          :form-data="addExtraPreviewFormData"
          extensions=".png,.jpg,.jpeg"
          @cancel="onCloseExtraPreview"
          @confirm="createExtraPreview"
        />

        <edit-comment-modal
          :active="modals.editComment"
          :is-loading="loading.editComment"
          :is-error="errors.editComment"
          :comment-to-edit="commentToEdit"
          :team="currentTeam"
          @confirm="confirmEditTaskComment"
          @cancel="onCancelEditComment"
        />

        <delete-modal
          :active="modals.deleteComment"
          :is-loading="loading.deleteComment"
          :is-error="errors.deleteComment"
          :text="$t('tasks.delete_comment')"
          :error-text="$t('tasks.delete_comment_error')"
          @confirm="confirmDeleteTaskComment"
          @cancel="onCancelDeleteComment"
        />

        <delete-modal
          :active="modals.deleteExtraPreview"
          :is-loading="loading.deleteExtraPreview"
          :is-error="errors.deleteExtraPreview"
          :text="$t('tasks.delete_preview')"
          :error-text="$t('tasks.delete_preview_error')"
          @cancel="onCancelRemoveExtraPreview"
          @confirm="confirmDeleteTaskPreview"
        />

        <edit-text-modal
          :active="modals.setCommentTitle"
          title="Close Comment"
          text="Give your closed thread a headline"
          placeholder="headline"
          @confirm="onConfirmCloseComment"
          @cancel="onCancelCloseComment"
        />

        <view-playlist-modal
          :active="modals.playlist"
          :task-ids="selectedTaskIds"
          sort
          @cancel="hidePlaylistModal"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {
  getTaskEntityPath,
  getTaskPath
} from '@/lib/path'
import {
  getTaskTypeStyle
} from '@/lib/render'
import { formatDateSimple } from '@/lib/time'
import { floorToFrame, roundToFrame } from '@/lib/video'
import { taskMixin } from '@/components/mixins/task'
import { domMixin } from '@/components/mixins/dom'
import moment from 'moment'

import csv from '@/lib/csv'
import drafts from '@/lib/drafts'

import AddPlainComment from '@/components/widgets/AddPlainComment'
import AddPreviewModal from '@/components/modals/AddPreviewModal'
import Comment from '@/components/widgets/Comment'
import DeleteModal from '@/components/modals/DeleteModal'
import EditCommentModal from '@/components/modals/EditCommentModal'
import EditTextModal from '@/components/modals/EditTextModal'
import Spinner from '@/components/widgets/Spinner'
import SubscribeButton from '@/components/widgets/SubscribeButton'
import TaskTypeName from '@/components/widgets/TaskTypeName'
import ActionSelect from '@/components/widgets/ActionSelect'
import TaskHistoryList from '@/components/lists/TaskHistoryList'
import ButtonSimple from '@/components/widgets/ButtonSimple'
import Combobox from '@/components/widgets/Combobox'
import Checkbox from '@/components/widgets/Checkbox'
import PreviewPlayer from '@/components/previews/PreviewPlayer'
import PeopleField from '@/components/widgets/PeopleField'
import ViewPlaylistModal from '@/components/modals/ViewPlaylistModal'
import preferences from '@/lib/preferences'

const READ_TIME_CODE_REGEX = /v(\d+) \d+:\d+\.\d+ \((\d+)\)(.*)/
const DEFAULT_PANEL_WIDTH = 350

export default {
  name: 'task-info',
  mixins: [domMixin, taskMixin],

  components: {
    AddPlainComment,
    AddPreviewModal,
    Comment,
    Combobox,
    Checkbox,
    DeleteModal,
    EditCommentModal,
    EditTextModal,
    Spinner,
    SubscribeButton,
    TaskTypeName,
    ActionSelect,
    ButtonSimple,
    TaskHistoryList,
    ViewPlaylistModal,
    PeopleField,
    PreviewPlayer
  },

  props: {
    task: {
      type: Object,
      default: () => {}
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    isPreview: {
      type: Boolean,
      default: true
    },
    isInPlayer: {
      type: Boolean,
      default: false
    },
    singleTask: {
      type: Boolean,
      default: true
    },
    silent: {
      type: Boolean,
      default: false
    },
    currentTimeRaw: {
      type: Number,
      default: 0
    },
    currentFrameRaw: {
      type: Number,
      default: 0
    },
    currentParentPreview: {
      type: Object,
      default: () => {}
    },
  },

  data () {
    return {
      addExtraPreviewFormData: null,
      attachedFileName: '',
      attachedImage: '',
      currentPreviewIndex: 0,
      currentPreviewPath: '',
      currentPreviewDlPath: '',
      currentTime: 0,
      copyDisabled: true,
      pasteDisabled: true,
      personFilter: null,
      commentToEdit: null,
      commentsSelected: {},
      commentAuthors: [],
      commentsToCopy: [],
      isSubscribed: false,
      isWide: true,
      isExtraWide: false,
      isShowHidden: false,
      quickPreviewadd: false,
      sortingOptions: [
        { value: 'date', label: 'Date' },
        { value: 'timecode', label: 'Timecode' },
      ],
      sorting: 'date',
      otherPreviews: [],
      previewForms: [],
      taskComments: [],
      taskPreviews: [],
      selectedTaskIds: [],
      errors: {
        addComment: false,
        addCommentMaxRetakes: false,
        addPreview: false,
        addExtraPreview: false,
        editComment: false,
        deleteComment: false,
        confirmDeleteTaskPreview: false,
        task: false
      },
      loading: {
        addComment: false,
        addPreview: false,
        addExtraPreview: false,
        editComment: false,
        deleteComment: false,
        confirmDeleteTaskPreview: false,
        task: false
      },
      modals: {
        addPreview: false,
        addExtraPreview: false,
        editComment: false,
        deleteComment: false,
        deleteExtraPreview: false,
        setCommentTitle: false,
        playlist: false,
      },
      domEvents: [
        ['mousemove', this.onExtendMove],
        ['touchmove', this.onExtendMove],
        ['mouseup', this.onExtendUp],
        ['mouseleave', this.onExtendUp],
        ['touchend', this.onExtendUp],
        ['touchcancel', this.onExtendUp]
      ],
      tab: 'comments' // 'tasks' or 'comments'
    }
  },

  mounted () {
    if (this.sideColumnParent) {
      const panelWidth =
        preferences.getIntPreference('task:panel-width') || DEFAULT_PANEL_WIDTH
      this.setWidth(panelWidth)
      this.refreshPreviewPlay()
    }
    this.loadTaskData()
    if (this.$refs['add-comment']) {
      const draft = drafts.getTaskDraft(this.task.id)
      if (draft) {
        this.$refs['add-comment'].text = draft
      }
    }
  },

  beforeDestroy () {
    this.removeEvents(this.domEvents)
    if (this.$refs['add-comment']) {
      const lastComment = `${this.$refs['add-comment'].text}`
      this.$store.commit('SET_LAST_COMMENT_DRAFT', lastComment)
    }
  },

  computed: {
    ...mapGetters([
      'currentEpisode',
      'currentProduction',
      'getTaskComment',
      'getTaskComments',
      'getTaskPreviews',
      'getTaskStatusForCurrentUser',
      'isCurrentUserAdmin',
      'isCurrentUserClient',
      'isCurrentUserSupervisor',
      'isCurrentUserManager',
      'isSingleEpisode',
      'isTVShow',
      'lastCommentDraft',
      'personMap',
      'previewFormData',
      'productionMap',
      'taskEntityPreviews',
      'taskStatusForCurrentUser',
      'taskTypeMap',
      'nbSelectedTasks',
      'selectedTasks',
      'user',
      'taskStatusMap',
      'taskMap'
    ]),

    previewOptions () {
      return this.taskPreviews.map((preview, index) => {
        return {label: `v${preview.revision}`, value: index}
      }).concat({label: 'v0', value: -1})
    },

    currentFrame () {
      return this.currentFrameRaw ? this.currentFrameRaw : Number(this.$refs['preview-player'].currentFrame)
    },

    weirdTasksSelected () {
      if (this.selectedTasks && this.selectedTasks.length > 0) {
        return this.selectedTasks.values().next().value
      } else if (this.task) {
        return this.task
      } else {
        return {}
      }
    },

    sideColumnParent() {
      if (this.$el.parentElement.classList.contains('side-column')) {
        return this.$el.parentElement
      }
      return undefined
    },

    currentFps() {
      return this.productionMap.get(this.task.project_id).fps || '25'
    },

    isPreviewPlayerReadOnly() {
      if (this.task) {
        if (this.isCurrentUserManager || this.isCurrentUserClient) {
          return false
        } else if (this.isCurrentUserSupervisor) {
          if (this.user.departments.length === 0) {
            return false
          } else {
            return !this.user.departments.includes(
              this.currentTaskType?.department_id
            )
          }
        }
      }
      return true
    },

    isGlobal () {
      if (this.weirdTasksSelected.project_id) {
        return false
      } else {
        return true
      }
    },

    isEntityBound () {
      if (this.weirdTasksSelected.entity_id) {
        return true
      } else {
        return false
      }
    },

    mainSelectedTask () {
      if (this.task) {
        return this.task
      } else {
        return this.weirdTasksSelected
      }
    },

    taskHasComments () {
      if (this.taskComments.length > 0) {
        for (const comment of this.taskComments) {
          if (comment.text !== '') {
            return true
          }
        }
      }
      return false
    },

    singleTaskSelected () {
      return this.nbSelectedTasks <= 1
    },

    prettyDueDate () {
      if (this.task.due_date) {
        return 'Due date: ' + formatDateSimple(this.task.due_date)
      } else {
        return 'Due date not set'
      }
    },

    currentTeam () {
      if (this.isGlobal) return []
      if (!this.task) return []
      const production = this.productionMap.get(this.task.project_id)
      return production.team.map(id => this.personMap.get(id))
    },

    title () {
      if (this.task) {
        if (this.isEntityBound) {
          const entityName =
            this.task.full_entity_name || this.task.entity_name
          return `${entityName}`
        } else {
          const taskType = ' / ' + this.task.task_type.name
          if (this.isGlobal) {
            return this.$t('global.title') + taskType
          } else {
            return this.$t('management.title') + taskType
          }
        }
      } else {
        return 'Loading...'
      }
    },

    isAssigned () {
      if (this.task) {
        return this.task.assignees.some(assigneeId => {
          return assigneeId === this.user.id
        })
      } else {
        return false
      }
    },

    isCommentingAllowed () {
      const isManager = this.isCurrentUserManager
      let isAssigned = true
      for (const selectedTaskId of this.selectedTasks.keys()) {
        if (!(this.user.id in this.selectedTasks.get(selectedTaskId).assignees)) {
          isAssigned = false
          break
        }
      }
      const isClientInPlaylist =
        this.$route.path.indexOf('playlist') > 0 && this.isCurrentUserClient
      return isManager || isAssigned || isClientInPlaylist
    },

    isSetThumbnailAllowed () {
      return this.currentPreviewId &&
        this.task &&
        this.task.entity &&
        // this.currentPreviewId !== this.task.entity.preview_file_id &&
        this.extension !== 'gif'
    },

    currentTaskType() {
      return this.task ? this.taskTypeMap.get(this.task.task_type_id) : null
    },

    currentPreview() {
      const index = this.currentPreviewIndex
      return this.taskPreviews && this.taskPreviews.length > 0
        ? this.taskPreviews[index]
        : null
    },

    currentPreviewId() {
      const index = this.currentPreviewIndex
      if (
        this.taskPreviews &&
        this.taskPreviews.length > 0 &&
        this.taskPreviews[index]
      ) {
        return this.taskPreviews[index].id
      } else {
        return null
      }
    },

    currentRevision () {
      return this.currentParentPreview && this.currentParentPreview.revision
        ? this.currentParentPreview.revision
        : this.currentPreview
        ? this.currentPreview.revision
        : 0
    },

    extension() {
      const index = this.currentPreviewIndex
      return this.taskPreviews && this.taskPreviews.length > 0
        ? this.taskPreviews[index].extension
        : ''
    },

    isStandardPreview() {
      return (
        this.taskPreviews &&
        this.taskPreviews.length > 0 &&
        [
          'ai',
          'blend',
          'ma',
          'mb',
          'pdf',
          'psd',
          'rar',
          'ae',
          'fla',
          'flv',
          'swf',
          'zip'
        ].includes(this.extension)
      )
    },

    isMoviePreview() {
      return (
        this.taskPreviews &&
        this.taskPreviews.length > 0 &&
        this.extension === 'mp4'
      )
    },

    isPicturePreview() {
      return (
        this.taskPreviews &&
        this.taskPreviews.length > 0 &&
        ['png', 'gif'].includes(this.extension)
      )
    },

    is3DModelPreview() {
      return (
        this.taskPreviews &&
        this.taskPreviews.length > 0 &&
        this.extension === 'obj'
      )
    },

    moviePath() {
      let previewId = null
      previewId = this.currentPreview.id
      return `/api/movies/originals/preview-files/${previewId}.mp4`
    },

    taskTypeStyle() {
      return getTaskTypeStyle(this.task)
    },

    taskPath () {
      if (this.isGlobal) {
        return {}
      } else {
        return getTaskPath(
          this.task,
          this.currentProduction,
          this.isTVShow,
          this.currentEpisode,
          this.taskTypeMap
        )
      }
    },

    taskEntityPath() {
      const episodeId = this.$route.params.episode_id
      return getTaskEntityPath(this.task, episodeId)
    },

    lastFivePreviews() {
      if (this.taskPreviews) {
        return this.taskPreviews.slice(0, 10)
      } else {
        return []
      }
    },

    lastFiveMoviePreviews () {
      if (this.taskPreviews) {
        const isMovie = previewFile => previewFile.extension === 'mp4'
        return this.taskPreviews.filter(isMovie).slice(0, 5)
      } else {
        return []
      }
    },

    lastFivePicturePreviews () {
      if (this.taskPreviews) {
        const isPicture = previewFile => previewFile.extension === 'png'
        return this.taskPreviews.filter(isPicture).slice(0, 5)
      } else {
        return []
      }
    },

    panelStyle () {
      return {
        width: this.isWide ? 700 : 350
      }
    },

    pinnedCount () {
      if (!this.taskComments) return 0
      return this.taskComments.filter(c => c.pinned).length
    },

    doneStatusId () {
      for (const key of this.taskStatusMap.keys()) {
        if (this.taskStatusMap.get(key).short_name === 'done') {
          return this.taskStatusMap.get(key).id
        }
      }
      return ''
    }
  },

  methods: {
    ...mapActions([
      'addAttachmentToComment',
      'ackComment',
      'addCommentExtraPreview',
      'clearSelectedTasks',
      'commentTask',
      'commentTaskWithPreview',
      'copyComments',
      'deleteAttachment',
      'deleteTaskComment',
      'deleteTaskPreview',
      'editTaskComment',
      'loadPreviewFileFormData',
      'loadTask',
      'loadTaskComments',
      'loadTaskSubscribed',
      'loadNotifications',
      'refreshPreview',
      'resetTaskNotificationsCount',
      'pinComment',
      'hideComment',
      'closeComment',
      'refreshComment',
      'setCommentTitle',
      'setPreview',
      'subscribeToTask',
      'unsubscribeFromTask',
      'updatePreviewAnnotation',
      'createSelectedTasks',
      'addTaskHistory'
    ]),

    onCreateClick () {
      const isAsset = this.$route.path.indexOf('asset') > 0 && !this.$route.params.asset_id
      this.createSelectedTasks({
        type: isAsset ? 'assets' : 'shots',
        projectId: this.currentProduction.id
      })
    },

    onCommentSelect (comment, event) {
      if (event) {
        this.commentsSelected[comment.id] = comment
      } else {
        delete this.commentsSelected[comment.id]
      }
      this.copyDisabled = Object.keys(this.commentsSelected).length === 0
    },

    onCopyClick () {
      if (this.copyDisabled) { return }
      this.commentsToCopy = Object.values(this.commentsSelected)
      this.pasteDisabled = this.commentsToCopy.length === 0
    },

    onPasteClick () {
      if (this.pasteDisabled) { return }
      const prev = this.currentPreview
      this.copyComments({
        taskId: this.task.id,
        commentIds: this.commentsToCopy.map(com => com.id),
        revision: prev ? prev.revision : 0
      })
    },

    hidePlaylistModal () {
      this.modals.playlist = false
    },

    generatePlaylist () {
      this.selectedTaskIds = Array.from(this.selectedTasks.keys())
      this.modals.playlist = true
    },

    onCloseClick () {
      if (this.isInPlayer) {
        this.$emit('close')
      } else {
        this.clearSelectedTasks()
      }
    },

    onCommentMarkClicked (commentId) {
      document.getElementById('com-' + commentId).scrollIntoView({ behavior: 'smooth' })
    },

    readTimecode (comment) {
      if (comment.text) {
        const times = comment.text.match(READ_TIME_CODE_REGEX)
        if (times && times.length > 3) {
          return {
            rev: Number(times[1]),
            frm: Number(times[2])
          }
        }
      }
      return {}
    },

    updateSorting () {
      this.taskComments = this.taskComments.sort((a, b) => {
        if (this.sorting === 'date') {
          return moment(a.created_at).isAfter(moment(b.created_at)) ? -1  : 1
        } else {
          const a_code = this.readTimecode(a)
          const b_code = this.readTimecode(b)
          if (a_code.rev === this.currentRevision) {
            if (b_code.rev === this.currentRevision) {
              if (a_code.frm === b_code.frm) {
                return moment(a.created_at).isAfter(moment(b.created_at)) ? -1  : 1
              } else {
                return a_code.frm < b_code.frm ? -1 : 1
              }
            } else {
              return -1
            }
          } else {
            if (b_code.rev === this.currentRevision) {
              return 1
            } else {
              return moment(a.created_at).isAfter(moment(b.created_at)) ? -1  : 1
            }
          }
        }
      })
    },

    reloadCommentMarks () {
      if (this.isPreview) {
        this.$refs['preview-player'].reloadComments()
      } else {
        this.$emit('reload-comment-marks')
      }
    },

    refreshPreviewPlay() {
      if (this.$refs['preview-player']) {
        this.$refs['preview-player'].previewViewer.resize()
      }
    },

    onExtendDown(event) {
      if (!this.sideColumnParent) {
        return
      }
      this.lastWidthX = this.getClientX(event)
      const panelWidth = this.sideColumnParent.offsetWidth
      this.lastWidth = panelWidth
      this.addEvents(this.domEvents)
    },

    onExtendMove(event) {
      const diff = this.lastWidthX - this.getClientX(event)
      let panelWidth = Math.max(this.lastWidth + diff, DEFAULT_PANEL_WIDTH)
      if (panelWidth > 900) panelWidth = 900
      this.setWidth(panelWidth)
      this.refreshPreviewPlay()
    },

    onExtendUp(event) {
      this.removeEvents(this.domEvents)
      this.refreshPreviewPlay()
      if (this.sideColumnParent) {
        const panelWidth = this.sideColumnParent.offsetWidth
        preferences.setPreference('task:panel-width', panelWidth)
      }
    },

    setWidth(width) {
      if (!this.sideColumnParent) {
        return
      }
      this.sideColumnParent.style['min-width'] = `${width}px`
      this.sideColumnParent.style['width'] = `${width}px`
      this.isWide = width > 699
      this.isExtraWide = width >= 900
    },

    onTimeUpdated(time) {
      this.currentTime = time
    },

    onTabCommentsClick () {
      this.tab = 'comments'
    },

    onTabTasksClick () {
      this.tab = 'tasks'
    },

    timeCodeClicked (
      { versionRevision, minutes, seconds, milliseconds, frame },
      commentIndex
    ) {
      if (!this.isPreview) {
        this.$emit(
          'time-code-clicked',
          { versionRevision, minutes, seconds, milliseconds, frame }
        )
        return
      }
      this.changeCurrentPreview(this.taskPreviews.find(
        p => p.revision === parseInt(versionRevision)
      ))
      setTimeout(() => {
        this.$refs['preview-player'].setCurrentFrame(frame - 1)
        this.$refs['preview-player'].focus({ behavior: 'smooth' })
      }, 20)
    },

    loadTaskData () {
      if (this.task) {
        this.loading.task = true
        this.errors.task = false
        this.loadTask({ taskId: this.task.id })
          .then(() => {
            this.loadTaskComments({
              taskId: this.task.id,
              entityId: this.task.entity_id
            })
              .then(() => this.reloadCommentMarks())
              .then(() => this.loadTaskSubscribed({ taskId: this.task.id }))
              .then(subscribed => {
                this.loading.task = false
                this.reset()
                this.isSubscribed = subscribed
              })
              .catch(err => {
                console.error(err)
                this.errors.task = true
              })
          })
        this.loadNotifications({
          task_id: this.task.id
        }).then(() => { this.resetTaskNotificationsCount(this.task.id) })
      }
    },

    addComment (comment, attachment, checklist) {
      if (this.singleTask && this.task) {
        this.commentTaskId(comment, attachment, checklist, this.task.task_status_id, this.task, false)
      } else if (this.selectedTasks) {
        for (const selectedTask of this.selectedTasks.values()) {
          this.commentTaskId(comment, attachment, checklist, selectedTask.task_status_id, selectedTask, false)
        }
      }
    },

    changeStatus (comment, attachment, checklist, taskStatusId) {
      if (this.singleTask && this.task) {
        this.commentTaskId('', attachment, checklist, taskStatusId, this.task)
      } else {
        for (const selectedTask of this.selectedTasks.values()) {
          this.commentTaskId('', attachment, checklist, taskStatusId, selectedTask)
        }
      }
    },

    commentTaskId (comment, attachment, checklist, taskStatusId, task, history=true) {
      const params = {
        taskId: task.id,
        taskStatusId,
        attachment,
        checklist,
        comment
      }
      const preview = this.currentPreview
      let action = 'commentTask'
      if (this.previewForms.length > 0) {
        action = 'commentTaskWithPreview'
        params['rev_num'] = preview ? preview.revision : 0
      } else {
        params['revision'] = preview ? preview.revision : 0
      }
      this.loading.addComment = true
      this.errors.addComment = false
      this.errors.addCommentMaxRetakes = false
      this.$store.dispatch(action, params)
        .then(() => {
          this.$refs['add-preview-modal'].reset()
          if (this.$refs['add-comment-image-modal']) {
            this.$refs['add-comment-image-modal'].reset()
          }
          drafts.clearTaskDraft(task.id)
          this.reset()
          this.attachedFileName = ''

          if (history && this.taskStatusMap.get(taskStatusId).is_retake) {
            this.addTaskHistory({
              taskId: task.id,
              assigneeIds: task.assignees,
              statusId: taskStatusId
            })
          }

          this.loading.addComment = false
          this.$emit('comment-added')
        })
        .catch((err) => {
          console.error(err)
          const isRetakeError =
            err.response &&
            err.response.body.message &&
            err.response.body.message.indexOf('retake') > 0
          this.errors.addComment = !isRetakeError
          this.errors.addCommentMaxRetakes = isRetakeError
          this.loading.addComment = false
        })
    },

    reloadCommentAuthors () {
      const authorDict = {}
      this.taskComments.forEach(comment => {
        authorDict[comment.person_id] = comment.person
      })
      this.commentAuthors = Object.values(authorDict)
    },

    reset() {
      this.resetModals()
      this.clearPreviewFiles()
      if (this.task) {
        this.taskComments = this.getTaskComments(this.task.id)
        this.reloadCommentAuthors()
        this.taskPreviews = this.getTaskPreviews(this.task.id)
        this.setOtherPreviews()
        this.currentPreviewPath = this.getOriginalPath()
        this.currentPreviewDlPath = this.getOriginalDlPath()
        this.resetDraft()
        this.$nextTick(() => {
          if (this.tab === 'comments' && this.$refs['add-comment']) this.$refs['add-comment'].focus()
        })
      }
    },

    focusCommentTextarea() {
      if (this.$refs['add-comment']) this.$refs['add-comment'].focus()
    },

    getOriginalPath() {
      const previewId = this.currentPreviewId
      const extension = this.extension ? this.extension : 'png'
      return `/api/pictures/originals/preview-files/${previewId}.${extension}`
    },

    getOriginalDlPath() {
      const previewId = this.currentPreviewId
      return `/api/pictures/originals/preview-files/${previewId}/download`
    },

    setOtherPreviews() {
      if (this.taskPreviews) {
        this.otherPreviews = this.taskPreviews.filter(p => {
          return p.id !== this.currentPreviewId && p.extension === 'mp4'
        })
      }
      return this.otherPreviews
    },

    selectFile(forms) {
      this.previewForms = this.previewForms.concat(forms)
      this.loadPreviewFileFormData(this.previewForms)
    },

    onPreviewFormRemoved(previewForm) {
      this.previewForms = this.previewForms.filter(f => f !== previewForm)
      this.loadPreviewFileFormData(this.previewForms)
    },

    clearPreviewFiles() {
      this.previewForms = []
      this.loadPreviewFileFormData(this.previewForms)
      this.$store.commit('CLEAR_UPLOAD_PROGRESS')
    },

    createExtraPreview(forms) {
      this.selectFile(forms)

      const index = this.currentPreviewIndex
      this.errors.addExtraPreview = false
      this.loading.addExtraPreview = true
      this.addCommentExtraPreview({
        taskId: this.task.id,
        commentId: this.taskComments[0].id,
        previewId: this.taskPreviews[index].id
      })
        .then(() => {
          this.loading.addExtraPreview = false
          this.$refs['add-extra-preview-modal'].reset()
          this.clearPreviewFiles()
          this.reset()
          setTimeout(() => {
            this.$refs['preview-player'].displayLast()
          }, 0)
          this.modals.addExtraPreview = false
        })
        .catch(err => {
          console.error(err)
          this.loading.addExtraPreview = false
          this.errors.addExtraPreview = true
        })
    },

    onPreviewAdded(eventData) {
      const taskId = eventData.task_id
      const commentId = eventData.comment_id
      const previewId = eventData.preview_file_id
      const revision = eventData.revision
      const extension = eventData.extension
      const comment = this.getTaskComment(taskId, commentId)

      if (this.task) {
        if (
          taskId === this.task.id &&
          comment &&
          (comment.previews.length === 0 ||
            comment.previews[0].id !== previewId)
        ) {
          this.$store.commit('ADD_PREVIEW_END', {
            preview: {
              id: previewId,
              revision,
              extension: extension
            },
            taskId,
            commentId,
            comment
          })
          this.reset()
        }
      }
    },

    onPreviewsOrderChange() {
      this.taskPreviews = this.getTaskPreviews(this.task.id)
      this.setOtherPreviews()
      this.currentPreviewPath = this.getOriginalPath()
      this.currentPreviewDlPath = this.getOriginalDlPath()
    },

    onAnnotationChanged({ preview, additions, deletions, updates }) {
      const taskId = this.task ? this.task.id : this.previousTaskId
      if (taskId) {
        this.updatePreviewAnnotation({
          taskId,
          preview,
          additions,
          deletions,
          updates
        })
      }
    },

    onAddPreviewClicked(quick=false) {
      this.quickPreviewadd = quick
      this.modals.addPreview = true
    },

    onAddExtraPreview() {
      this.clearPreviewFiles()
      this.modals.addExtraPreview = true
    },

    onRemoveExtraPreview(preview) {
      this.currentExtraPreviewId = preview.id
      this.modals.deleteExtraPreview = true
    },

    onCommentAdded() {
      this.taskComments = this.getTaskComments(this.task.id)
      this.reloadCommentAuthors()
    },

    onCancelRemoveExtraPreview() {
      this.modals.deleteExtraPreview = false
    },

    closeAddPreviewModal() {
      this.modals.addPreview = false
      this.quickPreviewadd = false
    },

    confirmAddPreviewModal(forms) {
      this.selectFile(forms)
      if (this.quickPreviewadd) {
        this.$store.commit('CLEAR_UPLOAD_PROGRESS')
        this.addComment("", [], [])
      }
      this.closeAddPreviewModal()
    },

    onCloseExtraPreview() {
      this.modals.addExtraPreview = false
    },

    onPreviewChanged() {
      if (this.currentPreviewIndex >= 0) {
        this.currentPreviewPath = this.getOriginalPath()
        this.currentPreviewDlPath = this.getOriginalDlPath()
        this.$emit('preview-changed', this.task.entity, this.currentPreview)
      }
    },

    changeCurrentPreview(previewFile) {
      const index = this.taskPreviews.findIndex(p => p.id === previewFile.id)
      if (index || index === 0) {
        this.currentPreviewIndex = index
        this.currentPreviewPath = this.getOriginalPath()
        this.currentPreviewDlPath = this.getOriginalDlPath()
      }
    },

    setCurrentPreviewAsEntityThumbnail() {
      this.setPreview({
        taskId: this.task.id,
        entityId: this.task.entity.id,
        previewId: this.currentPreviewId,
        frame: this.currentFrame,
        callback: () => {}
      })
    },

    toggleSubscribe () {
      if (this.task && !this.isAssigned) {
        if (this.isSubscribed) {
          this.unsubscribeFromTask(this.task.id)
          this.isSubscribed = false
        } else {
          this.subscribeToTask(this.task.id)
          this.isSubscribed = true
        }
      }
    },

    onAckComment (comment) {
      this.ackComment(comment)
    },

    onDuplicateComment(comment) {
      this.$refs['add-comment'].setValue(comment)
    },

    onPinComment(comment) {
      this.pinComment(comment)
    },

    onHideComment (comment) {
      this.hideComment(comment)
      this.$nextTick(() => {
        this.resetComments()
      })
    },

    onCloseComment(comment) {
      if (!comment.title && !comment.closed) {
        this.commentToEdit = comment
        this.modals.setCommentTitle = true
      } else {
        this.closeComment(comment)
        this.$nextTick(() => {
          this.resetComments()
        })
      }
    },

    onConfirmCloseComment (headline) {
      this.modals.setCommentTitle = false
      this.setCommentTitle({
        comment: this.commentToEdit,
        title: headline
      })
      this.closeComment(this.commentToEdit)
      this.$nextTick(() => {
        this.resetComments()
      })
    },

    onCancelCloseComment () {
      this.modals.setCommentTitle = false
    },

    onEditComment(comment) {
      this.commentToEdit = comment
      this.modals.editComment = true
    },

    onDeleteComment(comment) {
      this.commentToEdit = comment
      this.modals.deleteComment = true
    },

    onCancelEditComment() {
      this.modals.editComment = false
    },

    onCancelDeleteComment() {
      this.modals.deleteComment = false
    },

    saveComment(comment, checklist) {
      this.editTaskComment({
        taskId: this.task.id,
        comment,
        checklist
      })
    },

    confirmDeleteTaskComment() {
      this.animOn = true
      this.loading.deleteComment = true
      this.errors.deleteComment = false
      const commentId = this.commentToEdit.id

      this.deleteTaskComment({
        taskId: this.task.id,
        commentId
      })
        .then(() => {
          this.reset()
          this.loading.deleteComment = false
          this.modals.deleteComment = false
        })
        .catch(err => {
          console.error(err)
          this.loading.deleteComment = false
          this.errors.deleteComment = true
        })
        .finally(() => {
          this.animOn = false
        })
    },

    getCurrentTaskComments() {
      return this.getTaskComments(this.task.id)
    },

    confirmDeleteTaskPreview() {
      this.loading.deleteExtraPreview = true
      this.errors.deleteExtraPreview = false
      const previewId = this.currentExtraPreviewId
      const comment = this.getCurrentTaskComments().find(comment => {
        return comment.previews.findIndex(p => p.id === previewId) >= 0
      })

      this.$refs['preview-player'].displayFirst()
      this.deleteTaskPreview({
        taskId: this.task.id,
        commentId: comment.id,
        previewId
      })
        .then(() => {
          this.loading.deleteExtraPreview = false
          this.modals.deleteExtraPreview = false
        })
        .catch(err => {
          console.error(err)
          this.loading.deleteExtraPreview = false
          this.errors.deleteExtraPreview = true
        })
    },

    onRemoteAcknowledge(eventData, type) {
      if (this.task) {
        const comment = this.getTaskComment(this.task.id, eventData.comment_id)
        const user = this.personMap.get(eventData.person_id)
        if (comment && user) {
          if (this.user.id === user.id) {
            if (
              (type === 'ack' && !comment.acknowledgements.includes(user.id)) ||
              (type === 'unack' && comment.acknowledgements.includes(user.id))
            ) {
              this.$store.commit('ACK_COMMENT', { comment, user })
            }
          } else {
            this.$store.commit('ACK_COMMENT', { comment, user })
          }
        }
      }
    }
  },

  watch: {
    task () {
      this.commentsSelected = {}
      this.copyDisabled = true
      this.attachedFileName = ''
      this.previewForms = []
      this.currentPreviewIndex = 0
      if (
        this.previousTaskId &&
        this.$refs['add-comment']
      ) {
        const lastComment = `${this.$refs['add-comment'].text}`
        const previousDraft = drafts.getTaskDraft(this.previousTaskId)
        if (this.$refs['add-comment'].text.length > 0 || previousDraft) {
          drafts.setTaskDraft(this.previousTaskId, lastComment)
        }
      }
      this.$nextTick(() => {
        if (this.task) this.previousTaskId = this.task.id
        if (this.task && this.$refs['add-comment']) {
          const draft = drafts.getTaskDraft(this.task.id)
          if (draft) this.$refs['add-comment'].text = draft
        }
      })
      if (!this.silent) {
        this.loadTaskData()
      }
    },

    currentRevision() {
      this.updateSorting()
    },

    currentParentPreview() {
      if (this.currentParentPreview?.revision) {
        this.currentPreviewIndex = this.taskPreviews.findIndex(p => {
          return p.revision === this.currentParentPreview.revision
        })
        this.currentPreviewPath = this.getOriginalPath()
        this.currentPreviewDlPath = this.getOriginalDlPath()
      }
    }
  },

  socket: {
    events: {
      'preview-file:add-file'(eventData) {
        this.onPreviewAdded(eventData)
      },

      'preview-file:update' (eventData) {
        const preview = this.taskPreviews.filter((preview) => {
          return preview.id === eventData.preview_file_id
        })
        if (preview && this.task) {
          this.refreshPreview({
            taskId: this.task.id,
            previewId: eventData.preview_file_id
          }).then(() => {
            if (this.$refs['preview-movie']) {
              if (!this.$refs['preview-movie'].isDrawing) {
                this.$refs['preview-movie'].reloadAnnotations()
              }
            } else if (this.$refs['preview-picture']) {
              if (!this.$refs['preview-picture'].isDrawing) {
                this.$refs['preview-picture'].reset()
              }
            }
          })
        }
      },

      'task:update'(eventData) {
        const task = this.getTask()
        // Wait for data to be reinitialized by App.vue to update comments.
        if (task && eventData.task_id === task.id) {
          setTimeout(() => {
            const task = this.getTask()
            // in case the task changed during the timeout
            if (task && eventData.task_id === task.id) {
              this.taskComments = this.getTaskComments(task.id)
              this.reloadCommentAuthors()
            }
          }, 1000)
        }
      },

      'comment:new'(eventData) {
        setTimeout(() => {
          this.animOn = true
          const comments = this.task ? this.getTaskComments(this.task.id) : null
          if (
            this.task &&
            comments &&
            comments.length !== this.taskComments.length &&
            eventData.task_id === this.task.id &&
            !this.loading.task
          ) {
            this.taskComments = comments
            this.reloadCommentAuthors()
            this.taskPreviews = this.getTaskPreviews(this.task.id)
            this.reloadCommentMarks()
          }
          this.animOn = false
        }, 1000)
      },
      'comment:delete'(eventData) {
        if (
          this.task &&
          eventData.task_id === this.task.id &&
          !this.loading.task
        ) {
          this.reloadComments()
        }
      },
      'comment:reply'(eventData) {
        if (
          this.task &&
          eventData.task_id === this.task.id &&
          !this.loading.task
        ) {
          this.reloadComments()
        }
      },
      'comment:delete-reply'(eventData) {
        if (
          this.task &&
          eventData.task_id === this.task.id &&
          !this.loading.task
        ) {
          this.reloadComments()
        }
      },

      'comment:acknowledge'(eventData) {
        this.onRemoteAcknowledge(eventData, 'ack')
      },

      'comment:unacknowledge'(eventData) {
        this.onRemoteAcknowledge(eventData, 'unack')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dark {
  .add-comment,
  .comment,
  .no-comment {
    background: #46494f;
    border-color: $dark-grey;
    box-shadow: 0px 0px 6px #333;
  }

  .extend-bar {
    background: #46494f;
  }

  .no-preview {
    padding: 0.5em;
  }

  .side {
    background: #36393f;
  }

  .task-info {
    color: white;
  }

  .preview-label {
    background-color: $dark-grey;
  }

  .preview-selector {
    background-color: $dark-grey;
  }
}

.side-wrapper {
  width: inherit;
  display: flex;
  align-items: stretch;
  min-height: 100%;
}

.extend-bar {
  min-width: 5px;
  background: #ccc;
  cursor: ew-resize;
}

.side {
  background: #f8f8f8;
  min-height: 100%;
  width: calc(100% - 5px);
}

.add-comment {
  padding: 0.5em;
  margin-bottom: 0;
  box-shadow: 0px 0px 6px #e0e0e0;
}

.page-header {
  padding: 0;
  margin-top: 0;
}

.page-header {
  margin-bottom: 0;
  padding-bottom: 2px;
  padding-top: 2px;
  height: 35px;
  position: sticky;
  top: 0;
  background: var(--background);
  z-index: 20;
  // border-bottom: $black solid 1px;
}

.title {
  color: $grey;
  flex: 1;
  flex-grow: 1;
  font-size: 1.3em;
  font-weight: 500;
  line-height: 1.5em;
  margin: 0;
  margin-top: 0;
  text-wrap: nowrap;
}

.title a {
  color: inherit;
  padding-top: 10px;
  text-wrap: nowrap;
}

.history-button {
  flex: 1;
}

.no-comment {
  background: white;
  padding: 1em;
  border-radius: 5px;
  box-shadow: 0px 0px 6px #e0e0e0;
}

.task-columns {
  display: flex;
  flex-direction: column;
  margin-bottom: 1em;
}

.comment {
  border-top: 1px solid $white-grey;
  border-bottom: 1px solid $white-grey;
  border-right: 1px solid $white-grey;
  margin-top: 0.1em;
  box-shadow: 0px 0px 6px #e0e0e0;
}

.add-preview-button {
  margin-top: 0.5em;
  width: 100%;
}

.no-comment {
  background: white;
  box-shadow: 0px 0px 6px #e0e0e0;
}

.comments {
  padding: 0 6px 0 4px;
  // background: #f3f3f3;
}

.preview-column {
  z-index: 1;
}

.sticky-preview {
  position: sticky;
  top: 20px;
}

.preview-standard-file {
  text-align: center;
  padding: 1em;
}

.preview-player {
  margin-top: 1em;
}

.change-wideness-button,
.set-thumbnail-button,
.subscribe-button {
  margin-right: 0.2em;
}

.preview {
  position: relative;
}

.preview-list {
  height: 25px;
  background: var(--background-alt);
  border-bottom: solid 1px black;

  span {
    border-right: solid 1px black;
    padding: 0.2em;
    margin: 0;
    text-align: center;
    width: 100px;
  }
}

.rev-tab {
  cursor: pointer;

  &:hover {
    background: var(--background-selectable);
  }

  &.selected {
    background: var(--background);
  }
}

.active-tab-button {
  background-color: #00b242;
  color: white;
}

.bottom-column {
  margin-top: 0;
}

.left-button {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.right-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.tab-button {
  // background-color: lightgrey;
  // color: black;
  width: 50%;
}

.active-tab-button {
  background-color: #00b242;
  color: white;
}

.bottom-column {
  margin-top: 0;
}

.tasks-tab-button {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.comments-tab-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.tab-button {
  // background-color: lightgrey;
  // color: black;
  width: 50%;
}

.active-tab-button {
  background-color: #00b242;
  color: white;
}

.bottom-column {
  margin-top: 0;
}

.button-group {
  margin-bottom: auto;
}

.button-active {
  background: $green;
  color: $white;
}

.selector {
  margin-bottom: 0.5em;
}

.mt1 {
  margin-left: 0;
  margin-top: 0;
  padding-left: 4px;
  padding-bottom: 6px;
  padding-top: 6px;
  flex-wrap: wrap;
  position: sticky;
  top: 265px;
  background: var(--background);
  z-index: 10;
  border-bottom: $black solid 1px;
}

.vidmt {
  top: 290px;
}

.widemt {
  top: 535px;
}

.topmt {
  top: 35px;
}

.field {
  margin-bottom: 0;
}

.close-button {
  border-radius: 0 50% 50% 0;
  border-left: none;
  margin-right: 0.5em;
}

.upload-revision-button {
  background-color: $blue;
  color: $white
}

.btgrp {
  display: flex;
}

.disabled {
  background: $grey;
}

.create-button {
  background-color: #00b242;
  color: white;
  margin-left: 5%;
  margin-top: 10px;
  width: 90%;
  border-radius: 15px;
  height: 30px;
}

.preview-label {
  flex: 1;
  min-width: 0;
  max-width: fit-content;
  margin-right: 0;
  margin-left: 3px;
  text-transform: uppercase;
  padding: 4px 6px 0 5px;
  height: 29px;
  color: var(--text);
  background-color: $light-grey;
  border-radius: 10px 0 0 10px;
  font-size: 10pt;
  min-width: 22pt;
  overflow: hidden;
}

.preview-selector {
  height: 29px;
  margin-left: 0;
  background-color: $light-grey;
  border-radius: 0 10px 10px 0;
}

.original-name {
  color: $grey;
  margin-right: 20px;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  min-width: 0;
}

.due-date {
  flex-grow: 1;
  text-wrap: nowrap;
}

// .task-information {
//   margin-bottom: 4px;
// }
</style>
